import { Box, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { node_server } from "../../../../constants";
import { useTheme } from "../../../../context/themeContext";
import {
	setPublicGivenShoutOuts,
	setPublicReceivedShoutOuts,
} from "../../../../store/slices/profile/publicUserSlice";
import BasicTabs from "./components/tabs";
import styles from "./style.module.css";

function ShoutOuts() {
	const { theme } = useTheme();
	const dispatch = useDispatch();
	const publicUser = useSelector((state) => state.publicUser.value);

	useEffect(() => {
		const fetchGivenShoutOuts = async () => {
			const { data, error } = await axios.get(
				`${node_server}/api/shoutouts/given/${publicUser?.id}`,
				{
					withCredentials: true,
				},
			);

			if (error) console.log(error);
			if (data) dispatch(setPublicGivenShoutOuts(data));
		};

		const fetchReceivedShoutOuts = async () => {
			const { data, error } = await axios.get(
				`${node_server}/api/shoutouts/received/${publicUser?.id}`,
				{
					withCredentials: true,
				},
			);

			if (error) console.log(error);
			if (data) dispatch(setPublicReceivedShoutOuts(data));
		};

		fetchReceivedShoutOuts();
		fetchGivenShoutOuts();
	}, [publicUser]);

	return (
		<Box
			className={styles.newClassName}
			sx={{ backgroundColor: theme.palette.lightgrey.lightgrey600 }}
		>
			<Box className={styles.content}>
				<Typography
					variant="body1"
					sx={{
						fontSize: "1.5rem",
						fontWeight: "500",
						textAlign: "centerd",
						display: "flex",
						alignSelf: "stretch",
						alignItems: "center",
						justifyContent: "center",
						color: theme.palette.darkgrey.darkgrey600,
					}}
				>
					Shout Outs
				</Typography>
				<BasicTabs />
			</Box>
		</Box>
	);
}

export default ShoutOuts;
